import React from 'react'
import Img from 'gatsby-image'

const Information = ({attrs = {}, images = []}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		title: attrs?.title || null,
		informationContent: attrs?.informationContent || null,
		mediaId: attrs?.mediaId || null
	}

	// Vérification que images est un tableau
	const safeImages = Array.isArray(images) ? images : []

	const image = safeAttrs.mediaId && safeImages.find(({wordpress_id}) => wordpress_id === safeAttrs.mediaId)
	const imageSharpSizes = image && image.localFile && image.localFile.childImageSharp && image.localFile.childImageSharp.sizes

	return (
		<div className="block-information">
			<div className="block-information-title-n-thumb">
				{safeAttrs.title && (
					<div className="block-information-title" dangerouslySetInnerHTML={{__html: safeAttrs.title}} />
				)}
				<div className="block-information-thumb">
					{imageSharpSizes ? (
						<Img sizes={imageSharpSizes} alt="Image d'information" />
					) : (
						<div className="block-information-thumb-fake"></div>
					)}
				</div>
			</div>
			{safeAttrs.informationContent && (
				<div className="block-information-content" dangerouslySetInnerHTML={{__html: safeAttrs.informationContent}} />
			)}
		</div>
	)
}

export default Information
